import { attributeUUID } from "shared/attribute-uuid";

/**
 * Consumer Product Name once available (after Profiling), otherwise the supplier provided Product Name.
 * Returns an empty string when neither exists.
 */
export const getProductName = (attributes) => {
    return attributes?.[attributeUUID.syndigoCustomProductName] || attributes?.[attributeUUID.supplierProductName] || "";
};
